export type LogoCarouselProps = {
  logo: React.ReactNode;
};

export function LogoCarousel({ logo }: LogoCarouselProps) {
  return (
    <div className='flex w-[60px] justify-center pr-[25px] sm:pr-0 md:!w-[180px]'>
      {logo}
    </div>
  );
}
